<template>
  <b-modal
    ref="quotaModal"
    hide-header
    hide-footer
    size="md"
    centered
    @hidden="onHidden"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-py-3 tw-gap-3">
      <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-full tw-bg-amber-100">
        <i class="fe-alert-triangle tw-text-3xl tw-text-amber-600" />
      </div>
      <h5 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0">
        {{ $t('quota.modal.title') }}
      </h5>
      <div
        v-if="hasCounter"
        class="tw-rounded-md tw-bg-gray-100 tw-px-3 tw-py-1 tw-text-sm tw-font-semibold tw-text-gray-800"
      >
        {{ $t('quota.modal.counter', { current: payload.current, limit: payload.limit }) }}
      </div>
      <p class="tw-text-sm tw-text-gray-600 tw-m-0">
        {{ $t('quota.modal.body') }}
      </p>
      <p class="tw-text-xs tw-text-gray-500 tw-m-0">
        {{ $t('quota.modal.contact') }}
      </p>
      <div class="tw-pt-2">
        <b-button variant="primary" @click="close">
          {{ $t('quota.modal.close') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'QuotaExceededModal',

    computed: {
        ...mapState({
            visible: state => state.quota.visible,
            payload: state => state.quota.payload,
        }),

        hasCounter() {
            return typeof this.payload?.current === 'number' && typeof this.payload?.limit === 'number';
        },
    },

    watch: {
        visible(val) {
            if (val) this.$refs.quotaModal.show();
            else this.$refs.quotaModal.hide();
        },
    },

    methods: {
        close() {
            this.$store.dispatch('quota/hide');
        },
        onHidden() {
            // b-modal can close via backdrop / ESC; keep store in sync.
            if (this.visible) this.$store.dispatch('quota/hide');
        },
    },
};
</script>
